
import Home from '../pages/Home';
//import Competition from '../pages/Competition';
import Tournament from '../pages/Tournament';
import Features from '../pages/Features';
import Pricing from '../pages/Pricing';
import Contact from '../pages/Contact';
import Login from '../pages/Login';
import Register from '../pages/Register';
import PaymentSuccess from '../pages/PaymentSuccess';
import Transactions from '../pages/Transactions';
import TournamentRegistration from '../pages/TournamentRegistration';
import DemoPage from '../pages/DemoPage';
import ProductsComingSoon from '../pages/ProductsComingSoon';
import TournamentPlayers from '../pages/TournamentPlayers';


const publicRoutes = [
  { path: '', element: <Home /> },
  //{ path: 'competition', element: <Competition /> },
  { path: 'Tournament', element: <Tournament /> },
  { path: 'Features', element: <Features /> },
  { path: 'Pricing', element: <Pricing /> },
  { path: 'Contact', element: <Contact /> },
  { path: 'login', element: <Login /> },
  { path: 'register', element: <Register /> },
  { path: 'demo/:tenant', element: <DemoPage /> },

  { path: 'productscomingsoon', element: <ProductsComingSoon /> },
  // 🔒 Login required
  { path: 'payment_status', element: <PaymentSuccess />, requireAuth: true },
  { path: 'transactions', element: <Transactions />, requireAuth: true },
  { path: 'tournament-registration', element: <TournamentRegistration />, requireAuth: true },
  { path: 'tournament/:id/players', element: <TournamentPlayers /> },

];

export default publicRoutes;
